import styles from "../products/analytics-table.module.css";

export default function UserBehaviour({ data }) {
  return (
    <div className={styles.tableContainer}>
      <h2>User Behaviour</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Type</th>
              <th>Active Users</th>
              <th>Dormant Users</th>
              <th>High Value Users</th>
              <th>Total Users</th>
              <th>Avg Orders Per User</th>
              <th>Avg Spending Per User</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={index}>
                <td>{item._id}</td>
                <td>{item.activeUsers}</td>
                <td>{item.dormantUsers}</td>
                <td>{item.highValueUsers}</td>
                <td>{item.totalUsers}</td>
                <td>{item.avgOrdersPerUser}</td>
                <td>{item.avgSpendingPerUser}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
